/**
 * plugins/sentry.js
 *
 * Initialises Sentry for the Vue app. No-ops when VITE_SENTRY_DSN is unset
 * so local development and CI never report errors anywhere unintended.
 */
import * as Sentry from '@sentry/vue';

export function initSentry(app, router) {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  if (!dsn) return;

  Sentry.init({
    app,
    dsn,
    environment: import.meta.env.MODE,
    sendDefaultPii: false,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
    ],
    tracesSampleRate: 0.1,
    tracePropagationTargets: ['localhost', /^https:\/\/.*\.esteps\.health\//],
  });
}
